import { brandApi, affiliateApi, agencyApi } from '../lib/axios';

interface CreateSupportTicketPayload {
  description: string;
  mediaLinks: string[];
}

export const supportService = {
  async createTicket(data: CreateSupportTicketPayload, userRole:string) {
    let response: any;
    switch (userRole) {
      case 'brand':
         response = await brandApi.post('/support/create', data);
        return response.data;
      case 'affiliate':
         response = await affiliateApi.post('/support/create', data);
        return response.data;
      case 'agency':
         response = await agencyApi.post('/support/create', data);
        return response.data;
      default:
        throw new Error('Invalid user role');
    }
  }
}; 